import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Tooltip, useMediaQuery, useTheme } from "@mui/material";
import MenuList from "./MenuList";
import Logo from "../Logo";
import { useNavigate } from "react-router-dom";
import { useMedias } from "../../../contexts/Medias-Context/medias-context";

const SideMenu = ({
  open,
  onCloseHandler,
}: {
  open: boolean;
  onCloseHandler: () => void;
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const navigate = useNavigate();

  const { mediaFiles, slogan } = useMedias();

  const logoLightMode = mediaFiles.find(
    (media) => media.mediaType.code === "1"
  );
  const logoDarkMode = mediaFiles.find((media) => media.mediaType.code === "2");

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: 250 },
      }}
    >
      {!matches ? (
        <Box
          sx={(theme) => ({
            height: 1,
            position: "fixed",
            zIndex: 11,
            width: 250,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
          })}
        >
          <Box position={"absolute"} top={-10}>
            {theme.palette.mode === "light" && (
              <Tooltip
                title={slogan}
                disableHoverListener={slogan ? false : true}
              >
                <div>
                  <Logo
                    paddingTop={10}
                    logoWidth={"70%"}
                    src={
                      theme.palette.mode === "light" && logoLightMode
                        ? logoLightMode.cdnDomain + "/" + logoLightMode.filePath
                        : "/dimdim_logo.png"
                    }
                    alt={slogan || "Logo DimDim"}
                  />
                </div>
              </Tooltip>
            )}
            {theme.palette.mode === "dark" && (
              <Tooltip
                title={slogan}
                disableHoverListener={slogan ? false : true}
              >
                <div>
                  <Logo
                    paddingTop={10}
                    logoWidth={"70%"}
                    src={
                      logoDarkMode
                        ? logoDarkMode.cdnDomain + "/" + logoDarkMode.filePath
                        : "/dimdim_logo.png"
                    }
                    alt={slogan || "Logo DimDim"}
                  />
                </div>
              </Tooltip>
            )}
            <MenuList />
          </Box>
        </Box>
      ) : (
        <Drawer
          open={open}
          onClose={onCloseHandler}
          PaperProps={{
            sx: {
              width: 300,
            },
          }}
        >
          <Box
            paddingTop={5}
            paddingBottom={5}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"center"}
            onClick={() => navigate("")}
          >
            {theme.palette.mode === "light" && (
              <Tooltip
                title={slogan}
                disableHoverListener={slogan ? false : true}
              >
                <div>
                  <Logo
                    paddingTop={5}
                    logoWidth={"60%"}
                    src={
                      theme.palette.mode === "light" && logoLightMode
                        ? logoLightMode.cdnDomain + "/" + logoLightMode.filePath
                        : "/dimdim_logo.png"
                    }
                    alt={slogan || "Logo DimDim"}
                  />
                </div>
              </Tooltip>
            )}
            {theme.palette.mode === "dark" && (
              <Tooltip
                title={slogan}
                disableHoverListener={slogan ? false : true}
              >
                <div>
                  <Logo
                    paddingTop={5}
                    logoWidth={"60%"}
                    src={
                      logoDarkMode
                        ? logoDarkMode.cdnDomain + "/" + logoDarkMode.filePath
                        : "/dimdim_logo.png"
                    }
                    alt={slogan || "Logo DimDim"}
                  />
                </div>
              </Tooltip>
            )}
          </Box>
          <MenuList onClose={onCloseHandler} />
        </Drawer>
      )}
    </Box>
  );
};

export default SideMenu;
